<template>
<div class="case">
    <div style="display: flex;width:100%">
        <div align="left"  style="width:100%;font-size: 18px;margin-left:20%;">
        <h2>公司简介</h2>
        <p style="text-indent:3em;">辽宁智领未来科技有限公司，作为一家新兴的科技创新企业，自成立之初便秉持着“智慧引领，共创未来”的核心理念，的核心理念，我们致力</p>
        <p style="text-indent:1em;">于将人工智能、大数据、物联网等前沿科技深度融合，为传统道路交通行业注入强劲的数字动力，引领其向智能化、高效化、绿色化的新时代转型升</p>
        <p style="text-indent:1em;">级。我们的团队汇集了来自人工智能、计算机科学、交通工程等多个领域的行业人才，我们凭借深厚的技术积累与对行业需求的精准洞察，不断探索</p>
        <p style="text-indent:1em;">新技术在交通领域的应用边界。同时，我们秉持开放合作的理念，与国内多家科研机构、高校及行业伙伴建立紧密合作关系，共同推动智能交通技术</p>
        <p style="text-indent:1em;">的研发与应用落地。</p>
        <p style="text-indent:3em;">我们的核心产品包括但不限于：道路养护全生命周期管理系统，通过道路养护数据分析预测道路状态，有效提升道路通行效率与安全性；以及</p>
        <p style="text-indent:1em;">基于AI的桥梁维护预测系统，精准识别并预防潜在的桥梁问题，延长基础设施使用寿命。</p>
        <p style="text-indent:3em;">我们相信科技的力量能够重塑交通生态，让每一次出行都更加便捷、安全、环保。我们不仅是技术的探索者，更是未来智慧交通蓝图的绘制者。</p>
        <p style="text-indent:1em;">携手合作伙伴，共同开启道路交通行业的智能化新篇章，辽宁智领未来科技有限公司正以开放的姿态，邀您共创辉煌未来。</p>
        <h2>企业文化</h2>
        <p style="text-indent:3em;">在科技浪潮汹涌澎湃的时代背景下，辽宁智领未来科技有限公司应运而生，肩负着独特而伟大的使命。</p>
        <p style="text-indent:1em;">我们的使命是利用 AI、大数据、物联网技术，为道路交通智能化转型披荆斩棘。AI 智能系统如同拥有超强大脑，深度剖析交通数据，精确预测路况，</p>
        <p style="text-indent:1em;">为交通疏导提供科学蓝本；大数据平台汇聚海量信息，挖掘潜藏规律，助力交通规划有的放矢；物联网技术编织紧密网络，使车辆与道路设施互联互通</p>
        <p style="text-indent:1em;">构建高效协同的交通生态。借此，我们将大幅提升交通效率，削减拥堵，为社会运转注入强劲动力，同时以科技为坚盾，全方位保障道路安全，捍卫民</p>
        <p style="text-indent:1em;">众出行平安。</p>
        <p style="text-indent:3em;">公司以 “成为一家伟大的公司” 为愿景。这意味着我们要在道路交通智能化领域独占鳌头，成为行业标准的缔造者、创新的源泉。我们的影响力不仅要</p>
        <p style="text-indent:1em;">遍布全国，更要走向世界，用智能交通方案改善全球出行品质，用科技力量塑造城市新貌，为社会进步贡献核心力量，成为受世人敬仰、员工自豪、客</p>
        <p style="text-indent:1em;">户信赖的伟大企业。</p>
        <p style="text-indent:3em;">“奋斗、创新、责任、共赢” 是我们坚守的价值观。奋斗是我们的底色，全体员工以拼搏为笔，书写公司发展华章；创新是灵魂，激励我们突破传统，探</p>
        <p style="text-indent:1em;">索未知，以新技术、新理念领航行业；责任是担当，对产品质量精益求精，对社会公益积极践行，对环境保护身体力行；共赢是格局，与合作伙伴同呼吸</p>
        <p style="text-indent:1em;">、共命运，与客户携手共进，与员工共享成果，共创智能交通的辉煌未来，为人类交通事业的智能化进程不懈奋进。</p>
        <br>
        <br>
        <span style="font-weight: bold;">联系电话:</span> <span>18809867722</span>
        <br>
        <br>
        <span style="font-weight: bold;">邮箱:</span> <span>zlwl2025@163.com</span>
        <br>
        <br>
        <span style="font-weight: bold;">公司地址:</span> <span>辽宁省沈阳市和平区三好街94-1号同方广场A座3313室</span>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
     
      </div>

        </div>
     
      <!-- <div>
        <img  style="transform:scale(0.8)"  src="@/assets/logo5.png" alt="">
      </div> -->
    </div>
  </template>
  
  <script>
  export default {
    components: {
    },
    data(){
      return{
        types:[],
      }
    },
    methods:{
      //跳转页面
      jump(child){
        this.$router.push({ name: 'caseDetails', query: { id:child.id }});
      },
      //获取案例分类
      getTypes(){
        this.$apis.baseData.getClazz({pcode:'AL'}).then(res=>{
          this.types=res.data.list||[]
          if(this.types.length){
            for(let item of this.types){
              this.$set(item,'data',[])
              this.getTypesNext(item)
            }
          }
        })
      },
      //获取案例分类下的数据
      getTypesNext(item){
        this.$apis.baseData.getPage({clazzCode:item.code,"pageNum": "1", "pageSize": "1000"}).then(res=>{
          item.data=res.data.list||[]
        })
      },
    },
    mounted(){
      this.getTypes()
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .case{
    position: relative;
    justify-content: flex-start;
    margin-top:100px;
    text-align: center;
    width:100%;
    height:100%;
    display:flex;
    align-content: center;
    flex-direction: column;
    background: #fff;
   
  }
 
  
  </style>
  